import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useBlocker } from 'react-router-dom'

import { CustomConfirmDialog } from '../../components/dialogs'
import { NavBlockerContext } from './NavBlockerContext'

interface Props {
  children?: React.ReactNode
}

export const NavBlockerContextProvider: React.FC<Props> = ({ children }) => {
  const { t } = useTranslation()
  const [isBlocked, setIsBlocked] = useState<true[]>([])
  const [isVisible, setIsVisible] = useState(false)

  const handleShow = () => setIsVisible(true)
  const handleHide = () => setIsVisible(false)

  // Activate blocker when isBlocked is true
  // Allow the submission navigation to the same route to go through
  let blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      isBlocked[0] && currentLocation.pathname !== nextLocation.pathname,
  )

  // Set blocker
  const setBlocker = (value: boolean) => {
    if (value) {
      addBlocker()
    } else {
      deleteBlocker()
    }
  }

  const addBlocker = () => {
    setIsBlocked(prev => [...prev, true])
  }
  const deleteBlocker = () => {
    if (isBlocked.length) setIsBlocked(prev => prev.slice(1))
  }
  const deleteAllBlocker = () => {
    if (isBlocked.length) setIsBlocked([])
  }

  // Accept
  const handleAccept = () => {
    if (blocker && blocker.proceed) {
      deleteAllBlocker()
      blocker.proceed()
      handleHide()
    }
  }

  // Reject
  const handleReject = () => {
    if (blocker && blocker.reset) {
      blocker.reset()
      handleHide()
    }
  }

  // Show confirm dialog when isBlocked and blocker are true
  useEffect(() => {
    if (blocker.state === 'blocked' && isBlocked[0]) {
      handleShow()
    }
  }, [isBlocked, blocker])

  return (
    <NavBlockerContext.Provider value={{ setBlocker }}>
      <>{children}</>

      <CustomConfirmDialog
        severity="warning"
        isVisible={isVisible}
        header={t('common.unsavedChanges.header')}
        message={t('common.unsavedChanges.message')}
        rejectLabel={t('common.unsavedChanges.reject.label')}
        acceptLabel={t('common.unsavedChanges.accept.label')}
        onHide={handleReject}
        onReject={handleReject}
        onAccept={handleAccept}
        position="top"
      />
    </NavBlockerContext.Provider>
  )
}
